import { render } from "./edit-method-modal.vue?vue&type=template&id=570baa40&scoped=true"
import script from "./edit-method-modal.vue?vue&type=script&lang=js"
export * from "./edit-method-modal.vue?vue&type=script&lang=js"

import "./edit-method-modal.vue?vue&type=style&index=0&id=570baa40&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570baa40"]])

export default __exports__